'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.positionPixelsToGridPoints = exports.getNormalisedFontStyle = exports.getElementStyle = exports.calculateFontSize = exports.getGridSizeName = exports.calculateGridSize = exports.gridPointsToPixels = exports.pixelsToGridPoints = undefined;

var _point = require('../../../common/maths/geometry/point');

var pointsLib = _interopRequireWildcard(_point);

var _gridConstants = require('./gridConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Utils
var pixelsToGridPoints = exports.pixelsToGridPoints = function pixelsToGridPoints(pixels, gridSize) {
    return Math.round(pixels / gridSize);
};
var gridPointsToPixels = exports.gridPointsToPixels = function gridPointsToPixels(gridPoints, gridSize) {
    return gridPoints * gridSize;
};

var getGridSizeForWidth = function getGridSizeForWidth(windowWidth) {
    return _gridConstants.GRID_SIZE_LIST.reduce(function (currValue, size) {
        return size.breakpoint > windowWidth ? currValue : size;
    }, _gridConstants.GRID_SIZE_LIST[0]);
};

var calculateGridSize = exports.calculateGridSize = function calculateGridSize(windowWidth) {
    return getGridSizeForWidth(windowWidth);
};

var getGridSizeName = exports.getGridSizeName = function getGridSizeName(sizeName) {
    return 'app-size-' + sizeName;
};

var calculateFontSize = exports.calculateFontSize = function calculateFontSize(gridSize) {
    return gridSize * _gridConstants.FONT_SIZE_MULTIPLIER;
};

var getElementStyle = exports.getElementStyle = function getElementStyle(width, gridSize, noSetWidth) {
    return {
        width: !noSetWidth ? gridPointsToPixels(width, gridSize) : 'auto'
    };
};

var getNormalisedFontStyle = exports.getNormalisedFontStyle = function getNormalisedFontStyle(_ref) {
    var gridSize = _ref.gridSize,
        documentMode = _ref.documentMode;
    return {
        fontSize: documentMode ? 'inherit' : calculateFontSize(gridSize)
    };
};

var positionPixelsToGridPoints = exports.positionPixelsToGridPoints = function positionPixelsToGridPoints(position, gridSize) {
    return pointsLib.round(pointsLib.scale(1 / gridSize, position));
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/grid/gridUtils.js
// module id = 42
// module chunks = 0